var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image"},[_c('van-image',{staticClass:"img",style:(_vm.imageStyle),attrs:{"src":_vm.handleUrl}}),_c('div',{staticClass:"desc"},[_vm._v("发货物料")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }